<template>
  <el-steps :space="300" :active="active" align-center finish-status="success">
    <el-step :title="$t('Akaun Platform')"></el-step>
    <el-step :title="$t('Pengikatan tripartit')"></el-step>
    <el-step :title="$t('Informasi tambahan')"></el-step>
  </el-steps>
</template>

<script>
export default {
  name: 'StepsIndividual',
  props: ['active']
}
</script>
